import { render, staticRenderFns } from "./_EmentaTagCadastro.vue?vue&type=template&id=780106e4&scoped=true"
import script from "./_EmentaTagCadastro.vue?vue&type=script&lang=ts"
export * from "./_EmentaTagCadastro.vue?vue&type=script&lang=ts"
import style0 from "./_EmentaTagCadastro.vue?vue&type=style&index=0&id=780106e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780106e4",
  null
  
)

export default component.exports